import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-movie-2-line', title: '全集剧集索引', desc: '第一季 12 集一站式整理，剧集信息与详情页一一对应。' },
  { icon: 'ri-book-open-line', title: '详尽剧情介绍', desc: '每一集都配有详细剧情与角色说明，追剧不遗漏细节。' },
  { icon: 'ri-heart-3-line', title: '本地收藏追剧', desc: '一键收藏喜爱的剧集，数据保存在浏览器本地，刷新不丢失。' },
  { icon: 'ri-moon-clear-line', title: '沉浸观影体验', desc: '电影海报风格界面，夜色与月光交织的观看氛围。' },
];

const stats = [
  { value: '12', label: '第一季剧集' },
  { value: '6', label: '同类型推荐' },
  { value: '24h', label: '随时在线观看' },
  { value: '100%', label: '剧情资料完整' },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-secondary-300 uppercase">
            <i className="ri-moon-foggy-line"></i>
            About the site
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-50 leading-tight text-balance">
            专注「无颜之月」第一季的动漫视频与资料平台
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-300 leading-relaxed">
            本站以「无颜之月动漫第一季全集」为核心，围绕剧集播放、剧情介绍与角色资料展开，为喜爱这部作品的动漫迷提供权威、完整、易用的观看与查询体验。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-400 leading-relaxed">
            从焦点大图直达最新剧集，到分类目录的筛选排序，再到每一集的详细剧情——我们希望你在夜色般的界面里，顺畅地追上每一段故事。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-list-2-line"></i>
              开始追剧
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-background-800/70 border border-secondary-500/40 px-6 py-3 text-sm font-medium text-foreground-100 hover:bg-background-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line"></i>
              了解本站
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg bg-background-900 border border-primary-900/40 p-5 hover:border-primary-500/50 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-400 mb-3">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-50">{feature.title}</h3>
              <p className="mt-1.5 text-xs text-foreground-400 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="rounded-lg bg-gradient-to-br from-primary-900/40 to-secondary-900/30 border border-primary-800/40 px-5 py-6 text-center"
          >
            <p className="font-heading font-bold text-2xl md:text-3xl text-accent-400">{stat.value}</p>
            <p className="mt-1 text-xs md:text-sm text-foreground-300">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}